import { isNonEmptyVariable } from "@/util/common_function";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const NoAccess = ({ moduleName, subModuleName }) => {
  const [ud, setUD] = useState(null);
  const { userDetail } = useSelector((s) => s?.userDetail);

  useEffect(() => {
    if (isNonEmptyVariable(userDetail)) {
      setUD(() => userDetail);
    }
  }, [userDetail]);

  return (
    <>
      <h5>
        You do not have rights to the{" "}
        {isNonEmptyVariable(moduleName) ? moduleName + " module and" : " "}{" "}
        {isNonEmptyVariable(subModuleName)
          ? subModuleName + " sub module"
          : " "}{" "}
        . A user with rights must perform this step.
      </h5>
      <p>To enable access go to security menu and give access to user</p>
      {isNonEmptyVariable(ud) && ud?.staffGroup?.groups?.length ? (
        <>
          <p>This is the groups you associated with</p>
          <ul>
            {ud?.staffGroup?.groups?.map((g, i) => {
              return (
                <li key={i}>{g?.groupName + " (ID: " + g?.groupId + ")"}</li>
              );
            })}
          </ul>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default NoAccess;
